<script setup>
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/24/solid";

const props = defineProps({
  status: {
    type: [Boolean, Number, null],
    required: true,
  },
  align: {
    type: String,
    default: "left",
    required: false,
  },
  toggleCallback: {
    type: Function,
    required: false,
    default: null,
  },
});
</script>

<template>
  <div
    class="flex h-full items-center whitespace-nowrap p-4"
    :class="{
      'justify-start': props.align === 'left',
      'justify-center text-center': props.align === 'center',
      'justify-end': props.align === 'right',
    }"
  >
    <button
      @click="props.toggleCallback ? props.toggleCallback() : null"
      :class="{ 'cursor-pointer': props.toggleCallback }"
      :disabled="!props.toggleCallback"
    >
      <CheckCircleIcon
        v-if="props.status"
        class="size-5 text-green-500"
      />
      <XCircleIcon v-else class="size-5 text-red-500" />
    </button>
  </div>
</template>
